// extracted by mini-css-extract-plugin
module.exports = {"NotFountContainer":"Page404_NotFountContainer__g6pvN","NotFountH1":"Page404_NotFountH1__1JNM2","NotFountH2":"Page404_NotFountH2__1-sOC"};